import { t } from '../../i18n.es.js';
import { styled } from '@teko/ds-desktop';
import { DSSize } from '@teko/types/shared';
import React from 'react';

const sizeMaps = {
  [DSSize.small]: "24px",
  [DSSize.medium]: "32px",
  [DSSize.default]: "45px",
  [DSSize.large]: "55px"
};
const fontSizeMaps = {
  [DSSize.small]: "12px",
  [DSSize.medium]: "16px",
  [DSSize.default]: "20px",
  [DSSize.large]: "24px"
};
const DefaultCountdown = ({
  duration,
  size
}) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, duration.days > 0 && /* @__PURE__ */ React.createElement(CountdownText, null, t("K\u1EBFt th\xFAc sau"), " ", /* @__PURE__ */ React.createElement(Bold, null, duration.days), " ", t("ng\xE0y")), duration.milliseconds > 0 && /* @__PURE__ */ React.createElement(Timer, null, /* @__PURE__ */ React.createElement(Pad, {
    size
  }, duration.hours.toString().padStart(2, "0")), /* @__PURE__ */ React.createElement(Pad, {
    size
  }, duration.minutes.toString().padStart(2, "0")), /* @__PURE__ */ React.createElement(Pad, {
    size
  }, duration.seconds.toString().padStart(2, "0"))));
};
const CountdownText = styled.p`
  color: #fff;
  text-align: center;
  font-size: 1rem;
`;
const Bold = styled.span`
  font-weight: 600;
  font-size: 1.3rem;
`;
const Timer = styled.div`
  display: flex;
  justify-content: center;
`;
const Pad = styled.div(({ size }) => `
  width: ${sizeMaps[size]};
  height: ${sizeMaps[size]};
  font-size: ${fontSizeMaps[size]};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  margin-right: 8px;
  color: white;
  border-radius: 5px;
  background-image: linear-gradient(rgb(74, 74, 74), rgb(35, 34, 34));
`);

export { DefaultCountdown };
